import {push} from 'notivue';

export function notifyError(message) {

    console.log(message)
    if (typeof message === 'string') {
        push.error({
            title: 'Erro!',
            message,
            duration: 5000
        })
    } else if(message.status) {
        if (message.status === 422) {
            const keys = Object.keys(message.data);
            let data = '';

            keys.forEach(key => {
                data += `${message.data[key]}\n`;
            })

            push.error({
                title: 'Erro!',
                message: data,
                duration: 5000
            })
        } else if (message.status === 500) {
            push.error({
                title: 'Erro!',
                message: message.data.message,
                duration: 5000
            })
        }
    }
}

export function notifySuccess(message) {
    push.success({
        title: 'Sucesso!',
        message,
        duration: 5000
    })
}

export function getMessageError(data) {
    const keys = Object.keys(data);
    notifyError(data[keys[0]][0]);
}
